<template>
    <div id="mail">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">个人中心</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>
        <ul class="mailList">
            <li v-for="val in mailList">
                <h1 @click="toMail(val)">
                    {{val.title}}
                    <p>{{val.create_time}}</p>
                </h1>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Mail",
        data(){
            return {
                page : 1,
                lastPage : 1,
                limit : 10,
                total : 0,
                mailList : [],
            }
        },methods:{
            getMailList(){
                if(this.page > this.lastPage){
                    return false;
                }
                this.axios.post('/api/mail/getMailList').then(r => {
                    if(r.data.code){
                        this.mailList = r.data.data;
                    }
                })
            },
            toMail(obj){
                console.log(obj);
                if(obj.bw == 1){
                    if(obj.chapterid){
                        this.$router.push({name : 'Chapter',params : {wid : obj.bookid,cid : obj.chapterid}})
                    }else{
                        this.$router.push({name : 'Book',params : {wid : obj.bookid}})
                    }
                }else if(obj.bw == 2){
                    this.$router.push({path : obj.web})
                }else{
                    alert(obj.content)
                }
            }

        },
        created(){
            this.getMailList();
        }
    }
</script>

<style lang="less">
#mail{background: #f6f6f7;overflow: auto;height: 100%;
    .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }
    .mailList{background: #fff;margin-top: 20px;overflow: auto;
        li{border-bottom: 1px solid #efefef;padding: 20px;overflow: auto;
            h1{font-size: 28px;color: #666;
                p{font-size: 24px;color: #999;}
            }
            span{float: right;font-size: 24px;color: @theme;}
            .read{color: #999;}
        }
    }
}
</style>
